import queryString from 'query-string';
import { Button, SearchField } from '@leaftrade/leaftrade-component-library';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { DEBOUNCE_TIME } from '../../../constants';
import { PageHeaderSearchContainer } from './PageHeaderSearch.styles';

const PageHeaderSearch = ({ onSearch, placeholder }) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const searchParams = queryString.parse(search);
  const [searchQuery, setSearchQuery] = useState(
    searchParams.name_search || ''
  );

  const updateSearchQuery = useCallback(
    (newSearchQuery) => {
      setSearchQuery(newSearchQuery);
      searchParams.name_search = newSearchQuery;
      if (!newSearchQuery) {
        delete searchParams.name_search;
      }
      navigate(`${pathname}?${queryString.stringify(searchParams)}`);
      onSearch(queryString.stringify(searchParams));
    },
    [searchParams, pathname]
  );

  return (
    <PageHeaderSearchContainer data-testid='page-header-search--component--div'>
      <SearchField
        placeholder={placeholder}
        onChange={setSearchQuery}
        onSearch={updateSearchQuery}
        searchOn='change'
        debounceTime={DEBOUNCE_TIME}
        showClear={Boolean(searchQuery)}
        sx={{
          flex: 1,
        }}
        testingId='page-header-search--search-field--input'
        value={searchQuery || ''}
      />
      <Button
        onClick={() => updateSearchQuery(searchQuery)}
        testingId='page-header-search--search-button--button'
      >
        Search
      </Button>
    </PageHeaderSearchContainer>
  );
};

PageHeaderSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default PageHeaderSearch;
